import { render, staticRenderFns } from "./TableSimpleFixHeader.vue?vue&type=template&id=fa96c75e&"
import script from "./TableSimpleFixHeader.vue?vue&type=script&lang=js&"
export * from "./TableSimpleFixHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VListItemSubtitle,VSimpleTable})
